import customAxios from "../../customAxios";
import { FIND_ORDER } from "../../routes";
import { IRequestOrder } from "../../../types/order.interface";
import { ICreateAndUpdateCompany } from "../../../types/company.interface";
import { ICreateAndUpdateDriver } from "../../../types/driver.interface";
import { ICreateAndUpdateWorkTime } from "../../../types/workTime.interface";
import { IItem } from "../../../types/common.interface";

async function findOrder(props: IRequestOrder) {
  var thisUrl = FIND_ORDER;

  let body: any = {
    page: props.page,
    limit: props.limit,
    populate: [
      {
        path: 'client',
      },
      {
        path: 'workTime',
      },
      {
        path: 'address',
        populate: {
          path: 'county',
          model: 'County'
        }
      }],
  };

  if (props.search) {
    body = {
      ...body,
      search: {
        searchMode: props?.search?.base,
        searchValue: props?.search?.value,
      },
    };
  }
  if (props.filters) {
    const { company, driver, client, workTimes, cities, sendAll, status } =
      props?.filters;
    body = {
      ...body,
      company: (company as ICreateAndUpdateCompany)?._id,
      driver: (driver as ICreateAndUpdateDriver)?._id,
      client: (client as ICreateAndUpdateWorkTime)?._id,
      workTimes: (workTimes as ICreateAndUpdateWorkTime)?._id,
      cities,
      sendAll,
      status: (status as IItem)?.value,
    };
  }

  // !! ---------------------------------------------------------------------------------------------------------------------
  // !! =====================================================================================================================
  // !!                                            Try Catch For SuperAgent
  // !! =====================================================================================================================
  // !! ---------------------------------------------------------------------------------------------------------------------

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ FIND_ORDER: error });
  }
}

export default findOrder;
